import { render, staticRenderFns } from "./myPeas.vue?vue&type=template&id=2457913e&scoped=true"
import script from "./myPeas.vue?vue&type=script&lang=js"
export * from "./myPeas.vue?vue&type=script&lang=js"
import style0 from "./myPeas.vue?vue&type=style&index=0&id=2457913e&prod&scoped=true&lang=css"
import style1 from "./myPeas.vue?vue&type=style&index=1&id=2457913e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2457913e",
  null
  
)

export default component.exports